import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCj6rjcM6Cb4KSFZM4y7HA7jhpwi4ipjVY",
  authDomain: "the-clash-28c53.firebaseapp.com",
  projectId: "the-clash-28c53",
  storageBucket: "the-clash-28c53.firebasestorage.app",
  messagingSenderId: "1087018642356",
  appId: "1:1087018642356:web:88d9f7d01041a73e8e60e1",
  measurementId: "G-BBZNPFY42N",
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
